// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { FormFieldStyle } from "@rpsc/MobiusOverrides/FormField";
import { onePageCheckoutDeliveryMethodStyles } from "@rpsc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import { constants } from "@rpsc/XDL/constants";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.titleGridItem = {
    width: 12,
    css: css`
        &&&& {
            padding-bottom: 5px;
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.titleText = {
    variant: "h3",
    css: css`
        margin: 0;
    `,
};
onePageCheckoutDeliveryMethodStyles.container = {
    gap: 22,
    offsetCss: css`
        justify-content: space-between;
    `,
};
onePageCheckoutDeliveryMethodStyles.noCarriersFoundGridItem = onePageCheckoutDeliveryMethodStyles.servicesGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        &&&& {
            max-width: 454px;
            flex-direction: column;
            gap: 12px;
            ${xScreen("lte", constants.onePageCheckout.tablet)} {
                max-width: 100%;
            }
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.deliveryDateGridItem = onePageCheckoutDeliveryMethodStyles.pickUpDateGridItem = {
    width: [12, 12, 12, 12, 6, 6],
    css: css`
        &&&& {
            max-width: 454px;
            flex-direction: column;
            gap: 12px;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
        & > div,
        & ${FormFieldStyle} {
            width: 100%;
            display: flex;
        }
    `,
};

onePageCheckoutDeliveryMethodStyles.methodGroup = {
    css: css`
        width: 100%;
        & > ${TypographyStyle} {
            font-size: 12px;
            line-height: 17px;
            margin-bottom: 4px !important;
            &::after {
                content: "*";
                color: ${color("danger")};
                margin-left: 4px;
                line-height: 14px;
            }
        }
    `,
};

onePageCheckoutDeliveryMethodStyles.methodsBox = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
    `,
};

onePageCheckoutDeliveryMethodStyles.carrierLine = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

onePageCheckoutDeliveryMethodStyles.notify = {
    css: css`
        max-width: 100%;
        margin: 0;
    `,
};

onePageCheckoutDeliveryMethodStyles.deliveryDatePicker = {
    mergeCss: true,
    cssOverrides: {
        descriptionWrapper: css`
            ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.xSmall};
                line-height: 17px;
            }
        `,
    },
};
